import { showErrorToast } from "@configs/react-toastify/snackbar";

export const validateDuplicateRules = (licensePolicyRules, t) => {
  const duplicates = [];
  const policyStepConflicts = [];
  const ruleMap = new Map();

  licensePolicyRules.forEach((rule) => {
    const key = `${rule.licenseIdentifier?.trim() || ""}-${rule.licenseName?.trim() || ""}-${rule.matchTypeCd?.trim() || ""}-${rule.modificationFlag?.trim() || ""}-${rule.patentFlag?.trim() || ""}`;

    if (ruleMap.has(key)) {
      // Found duplicate
      const existingRule = ruleMap.get(key);
      const duplicateInfo = rule.licenseIdentifier;

      // Check if policyStep is different
      if (rule.policyStep !== existingRule.policyStep) {
        const conflictInfo = `${duplicateInfo}`;
        if (!policyStepConflicts.includes(conflictInfo)) {
          policyStepConflicts.push(conflictInfo);
        }
      } else {
        // Same policyStep - regular duplicate
        if (!duplicates.includes(duplicateInfo)) {
          duplicates.push(duplicateInfo);
        }
      }
    } else {
      ruleMap.set(key, rule);
    }
  });

  // Show policy step conflicts first (higher priority)
  if (policyStepConflicts.length > 0) {
    showErrorToast(
      t("status.error"),
      `${t("license-policy.duplicate-rules-different-steps-error")} ${policyStepConflicts.join(", ")}`,
    );
    return false;
  }

  // Show regular duplicates
  if (duplicates.length > 0) {
    showErrorToast(t("status.error"), `${t("license-policy.duplicate-rules-error")} ${duplicates.join(", ")}`);
    return false;
  }

  return true;
};
